import { Button, Box, Typography, Link } from '@mui/material';
import ResourceCard from '../../components/ResourceCard';
import IncentiveCard from '../../components/IncentiveCard';
import { useState } from 'react';

const SLICE_SIZE = 3;

export default function ProgramsAndIncentives({
  resources,
  incentivesForRoom,
  incentiveImgix,
  buildOnClick,
}) {
  const [expanded, setExpanded] = useState(false);

  const all = [
    ...incentivesForRoom.map((incentive) => ({ incentive })),
    ...resources.map((resource) => ({ resource })),
  ];

  if (all.length === 0) {
    return null;
  }

  const slice = expanded ? all : all.slice(0, SLICE_SIZE);

  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="h3" fontWeight={600} mb={0.5}>
        Programs and Incentives
      </Typography>
      <Typography mb={2}>
        These programs and incentives are available to you, click into each to learn about specific
        qualifications. For additional programs and incentives that may be available see{' '}
        <Link
          href="https://incentives.switchison.org/residents/incentives"
          target="_blank"
          rel="noopener"
        >
          The Switch Is On
        </Link>
        .
      </Typography>

      <Box display="flex" flexDirection="column">
        {slice.map(({ incentive, resource }, index) => (
          <Box key={index} mb={2}>
            {incentive ? (
              <IncentiveCard incentive={incentive} incentiveImgix={incentiveImgix} />
            ) : (
              <ResourceCard resource={resource} onClick={buildOnClick(resource.id)} />
            )}
          </Box>
        ))}
      </Box>
      {all.length > SLICE_SIZE && (
        <Box>
          <Button onClick={() => setExpanded(!expanded)} fullWidth>
            {expanded ? 'See Fewer' : 'See More'}
          </Button>
        </Box>
      )}
    </Box>
  );
}
